'use strict';

var i18n = require('i18next');
var EditLanIsolationGlobal = require('actions/lanIsolationGlobal/EditLanIsolationGlobal');
var FormView = require('actions/lanIsolationGlobal/FormView');
var StaticView = require('actions/lanIsolationGlobal/StaticView');

/**
 * Action configuration for the "Global LAN Segregation" option.
 */
module.exports = {
  title: i18n.t('actionLanIsolationGlobal.title'),
  Model: EditLanIsolationGlobal,
  FormView: FormView,
  TextView: StaticView,
};
